import { jsx as _jsx } from "react/jsx-runtime";
import StickyHeaderTable from '../table/StickyHeaderTable';
export const HistoryTable = (props) => {
    const { data, withdrawTxColumns, history, isLoading, pageSize = 20, cellHeight = 56, topContent, bottomContent, emptyText, type, } = props;
    return (_jsx(StickyHeaderTable, { data: data, columns: withdrawTxColumns, isLoading: isLoading, pageSize: pageSize, total: history?.total || 0, tableHeight: history?.list.length >= 9
            ? cellHeight * (history?.list.length > pageSize ? pageSize : history?.list.length + 1)
            : 56 * 9, cellHeight: cellHeight, emptyText: emptyText, topContent: topContent ? topContent : null, bottomContent: bottomContent ? bottomContent : null, type: type }));
};
